import { Controller } from "@hotwired/stimulus";
import { createRoot } from "react-dom/client";
import { Wrapper as QueryClientProvider } from "../helpers/queryClient";
import PermissionPicker from "../components/shared/PermissionPicker";

// Connects to data-controller="permission-picker"
// Intended be used on a text input containing JSON
export default class extends Controller {
  static values = {
    groupSlug: String,
  };

  connect() {
    this.originalType = this.element.type;
    this.element.type = "hidden";

    const container = document.createElement("div");
    this.element.insertAdjacentElement("afterend", container);
    this.root = createRoot(container);
    const initialValue = JSON.parse(this.element.value || "[]");
    this.handleChange(initialValue);
  }

  handleChange = (newValue) => {
    this.element.value = JSON.stringify(newValue);
    const query = {
      include_membership_roles: true,
      ...(this.groupSlugValue && {
        group_slug: this.groupSlugValue,
        section: "members",
        per_page: 25,
      }),
    };

    this.root.render(
      <QueryClientProvider>
        <PermissionPicker
          value={newValue}
          onChange={this.handleChange}
          query={query}
        />
      </QueryClientProvider>,
    );
  };

  disconnect() {
    if (this.root) {
      this.root.unmount();
      this.element.type = this.originalType;
    }
  }
}
